import styled from "@emotion/styled";

const NullValue = styled.div`
  text-transform: uppercase;
  color: gray;
  font-style: italic;
  font-weight: 500;
`;

export default NullValue;